/** 관리 대시보드 집계 API — /api/admin/dashboard. */
import { apiClient } from './client';

export interface DashboardData {
  institution: { name: string; code: string } | null;
  users: { total: number; active: number; byRole: Record<string, number> } | null;
  modules: { items: Array<{ key: string; enabled: boolean }>; enabled: number; total: number } | null;
  menus: { total: number; enabled: number } | null;
  icons: { total: number } | null;
  externalServices: { total: number; enabled: number } | null;
  customServices: { total: number; enabled: number } | null;
  aiProvider: { activeId: string | null; name: string | null; model: string | null; envCount: number; cliCount: number } | null;
  aiTools: { total: number; domains: number } | null;
}

export async function getDashboard(): Promise<DashboardData> {
  const { data } = await apiClient.get<DashboardData>('/admin/dashboard', { timeout: 15_000 });
  return data;
}
